import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-graph",
  "use": "icon-graph-usage",
  "viewBox": "0 0 37 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 36\" id=\"icon-graph\"><path d=\"M0 0v36h36v-3H3V17.78l9.146 6.161 9.07-12.087 7.598 6.246 7.268-10.38-2.458-1.723-5.408 7.726-7.512-6.18-9.246 12.317L3 14.162V0H0Z\" fill=\"#0284C7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol